import { createCachedSelector, defaultKeySelector, bound } from '@cbridge-utils/redux';
import { createDefaultCachedSelectorOptions } from '@cbridge-utils/reselect';
import { ClientFeature, isFeatureEnabledSelector } from '@cbridge-packages/auth';

export interface IClientPageVisibility {
  /** Trading-related pages (order routing, non-pricing profiles, reports, …): the basicBridge feature (LB-4724) */
  isTradingVisible: boolean;
  /** Markout report: the markoutReport feature, or riskManagement (independent markout) */
  isMarkoutVisible: boolean;
  isQuotesDashboardVisible: boolean;
  /** External reporting is coverage, i.e. trading: needs basicBridge on top of its own feature */
  isExternalReportingVisible: boolean;
}

const isEnabled = (feature: ClientFeature) => bound(isFeatureEnabledSelector, { feature });

export const clientPageVisibilitySelector = createCachedSelector(
  [
    isEnabled(ClientFeature.BasicBridge),
    isEnabled(ClientFeature.RiskManagement),
    isEnabled(ClientFeature.MarkoutReport),
    isEnabled(ClientFeature.QuotesDashboard),
    isEnabled(ClientFeature.ExternalReporting),
  ],
  (basicBridge, riskManagement, markoutReport, quotesDashboard, externalReporting): IClientPageVisibility => ({
    isTradingVisible: basicBridge,
    isMarkoutVisible: markoutReport || riskManagement,
    isQuotesDashboardVisible: quotesDashboard,
    isExternalReportingVisible: basicBridge && externalReporting,
  }),
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: defaultKeySelector,
});
